import { useModalWithHashingControl } from '@app/components/ModalResponsive';
import UserInformationsManagerModal from '@app/components/UserInformationsManagerModal';
import { Address, User } from '@app/types';
import { UserFormatter } from '@app/utils/formmater';
import React, { useEffect } from 'react';
import classes from './styles.module.css';

type Props = {
  user: User | null;
  onUserChange: (user: User | null) => void;
  onContainerRef?: (containerRef: HTMLElement | null) => void;
};

export default function PersonalDataBox({ user, onUserChange, onContainerRef }: Props) {
  const userModal = useModalWithHashingControl('dados-pessoais');

  function handleChangePersonalDataClick() {
    userModal.open();
  }

  function handleSaveInformations(_: Address | null, user: User | null) {
    userModal.close();
    onUserChange(user);
  }

  return (
    <>
      <div className={classes.addressBox} ref={onContainerRef} onClick={handleChangePersonalDataClick}>
        {user && (
          <>
            <span>Dados pessoais</span>
            <p>
              {user.name}, {UserFormatter.getFormattedPhone(user.cellphone)}
            </p>
          </>
        )}

        <div className={classes.changeAddress}>Editar</div>
      </div>
      <UserInformationsManagerModal
        isVisible={userModal.state}
        onClose={() => userModal.close()}
        user={user}
        onSave={handleSaveInformations}
        hiddenAddressInputs={true}
      />
    </>
  );
}
